import { create } from '@/utils/api'
import router from '../router/index'
import { Message } from 'element-ui'
export default class Constant {
	/**
	 * 图片翻译包id
	 */
	static TOOL_IMAGE_ID = 3003
	/**
	 * 开发专业版projectId: dev
	 */
	static PROJECT_ID_DEV = 'dev'
	static PROJECT_ID_HWB = 'hwb'
	/**
	 * 顶部版本id
	 */
	static MODULES_OBJ = {
		plateformId: 1,
		toolId: 3,
		serve: 4,
		purchased: 2,
		cloud: 5,
		openapi: 6,
	}
}
//马帮支付

export let mabangPay = (data) => {
	if (!JSON.parse(sessionStorage.getItem('sourceInfo'))) {
		Message.error({ message: '请登录！' })
		return
	}
	let params = {
		goodsId: data.goodsId,
		buyNum: data.buyNum,
		source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
		recharge: 0,
	}
	if (data.recharge == 1) {
		params.recharge = 1
	}
	if (data.purchaseTime) {
		params.purchaseTime = data.purchaseTime
	}
	if (data.attributeId) {
		params.attributeId = data.attributeId
	}
	create(params).then((res) => {
		if (res) {
			router.push({
				path: '/pay',
				query: {
					orderNo: res.orderNo,
					moduleId: data.moduleId,
				},
			})
			// res.icon = require('../../assets/images/alipay.png')
			// this.orderPay = res
			// this.ultimatelyPay = res.price
		}
	})
}
